import { useState, Dispatch, SetStateAction } from 'react';

// adapted from https://usehooks.com/useLocalStorage/

const useLocalStorage = <V>(key: string, initialValue: V): [V, Dispatch<SetStateAction<V>>] => {
  // TODO: check for localStorage support and handle this case gracefully
  // right now it will just catch and print an error to the console
  const [storedValue, setStoredValue] = useState<V>(() => {
    try {
      const item = window.localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      console.error(error);
      return initialValue;
    }
  });

  const setValue: Dispatch<SetStateAction<V>> = value => {
    try {
      const valueToStore = value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      window.localStorage.setItem(key, JSON.stringify(valueToStore));
    } catch (error) {
      console.error(error);
    }
  };

  return [storedValue, setValue];
};

export default useLocalStorage;
